package com.anjuros.website.redesign.sections.pricing

import androidx.compose.runtime.Composable
import com.anjuros.website.redesign.components.RdClosingCard
import com.anjuros.website.redesign.util.RdRoute
import com.anjuros.website.redesign.util.RdText

@Composable
fun PricingClosingSection() {
    RdClosingCard(
        RdText.PRICING_CLOSE_EYEBROW, RdText.PRICING_CLOSE_TITLE, RdText.PRICING_CLOSE_LEDE,
        secondaryText = RdText.CTA_SEE_ALL_DESIGNS, secondaryPath = RdRoute.DESIGNS,
    )
}
